export const DARK_MODE_STORAGE_KEY = 'hp_dark_mode_state';
